// Country list (subset of common countries with Sweden first as default)
export const countries: string[] = [
  "Sverige",
  "Norge",
  "Danmark",
  "Finland",
  "Island",
  "Tyskland",
  "Polen",
  "Estland",
  "Lettland",
  "Litauen",
  "Storbritannien",
  "Irland",
  "Nederländerna",
  "Belgien",
  "Frankrike",
  "Spanien",
  "Italien",
  "Portugal",
  "Schweiz",
  "Österrike",
  "Tjeckien",
  "Slovakien",
  "Ungern",
  "Slovenien",
  "Kroatien",
  "Bulgarien",
  "Rumänien",
  "Grekland",
  "Turkiet",
  "Ryssland",
  "Ukraina",
  "Vitryssland",
  "USA",
  "Kanada",
  "Mexico",
  "Brasilien",
  "Argentina",
  "Chile",
  "Australien",
  "Nya Zeeland",
  "Japan",
  "Kina",
  "Indien",
  "Sydafrika",
  "Annat land",
];

export const businessForms = [
  "Aktiebolag",
  "Enskild firma",
  "Handelsbolag",
  "Kommanditbolag",
  "Ekonomisk förening",
  "Ideell förening",
  "Stiftelse",
  "Annat",
];

export const industries = [
  "Logistik & Transport",
  "Sågverk",
  "Återförsäljare",
  "Skogsbruk",
  "Träförädling",
  "Fastighet & Mark",
  "Maskin & Utrustning",
  "Konsult & Rådgivning",
  "Annat",
];

export const employeeRanges = [
  "1–5",
  "6–20",
  "21–100",
  "101–500",
  "500+",
];

// Free email domains we block for company registration
const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.se",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.se",
  "ymail.com",
  "outlook.com",
  "outlook.se",
  "live.com",
  "live.se",
  "icloud.com",
  "me.com",
  "mac.com",
  "msn.com",
  "aol.com",
  "protonmail.com",
  "proton.me",
  "gmx.com",
  "gmx.se",
  "mail.com",
  "telia.com",
  "comhem.se",
  "spray.se",
  "bredband.net",
  "tele2.se",
]);

export function isFreeEmailDomain(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const domain = email.slice(at + 1).toLowerCase().trim();
  return FREE_EMAIL_DOMAINS.has(domain);
}

// Swedish org number: 10 digits, often shown as XXXXXX-XXXX.
export function isValidSwedishOrgNumber(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10) return false;
  // Luhn check (Swedish org numbers use the same algorithm)
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let d = parseInt(digits[i], 10);
    if (i % 2 === 0) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
}

export function isValidOrgNumberForCountry(value: string, country: string): boolean {
  if (!value.trim()) return false;
  if (country === "Sverige") {
    // Either luhn-valid or at least matches the format XXXXXX-XXXX (lenient: accept format only)
    const formatOk = /^\d{6}-?\d{4}$/.test(value.trim());
    return formatOk;
  }
  // Non-Swedish: any alphanumeric (with dashes/spaces) of reasonable length
  return /^[A-Za-z0-9\s\-./]{4,32}$/.test(value.trim());
}

export function completeSocialUrl(value: string, platform: string): string | null {
  if (!value) return null;
  if (value.startsWith("http://") || value.startsWith("https://")) return value;
  const baseUrls: Record<string, string> = {
    facebook: "https://www.facebook.com/",
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/in/",
    whatsapp: "https://wa.me/",
    skogsforum: "https://www.skogsforum.se/members/",
  };
  const handle = platform === "whatsapp" ? value.replace(/[\s-]/g, "") : value;
  return (baseUrls[platform] ?? "") + handle;
}
